import _extends from "@babel/runtime/helpers/extends";
import { seoJoinSplitUrl } from '../seoJoinSplitUrl/seoJoinSplitUrl';
import Url from '../urlParse';

// /borderscaler/400/200/0000ff/path_to_image.jpg

export var SCALER_PREFIX = 'scaler';
export var RESIZE_SCALER_PREFIX = 'resize';

// Images from source - Autotrader.
export var IMAGE_SERVERS = ['images.autotrader.com', 'atcimages.kbb.com', seoJoinSplitUrl('img', 'fordblueadvantage', 'com'), seoJoinSplitUrl('images', 'fordblueadvantage', 'com'), 'external-images-sdc.autotrader.com', 'external-images-cp.autotrader.com', 'external-images-dd.autotrader.com', 'images2.autotrader.com', 'images.qa.autotrader.com', 'images-preprod.autotrader.com', seoJoinSplitUrl('images-test', 'fordblueadvantage', 'com')];

// Images from source - Cox Auto Media Management.
export var ASSET_IMAGE_SERVERS = ['assets.cai-media-management-np.com', 'assets.cai-media-management.com'];
var sizePattern = '[0-9]+';
var resizePattern = '[\\d+[x]\\d+]';
export var joinPath = function joinPath() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args.join('/');
};

// If an image is hosted by an ATC image server (so that we know we may add the scaler string) and has non-zero area
var isImageScalable = function isImageScalable(_ref) {
  var hostname = _ref.hostname,
    height = _ref.height,
    width = _ref.width;
  return IMAGE_SERVERS.includes(hostname) && Number.parseInt(width, 10) > 0 && Number.parseInt(height, 10) > 0;
};
var parseSrc = function parseSrc(src, pattern) {
  // url.parse() does not support protocol-relative URLs, so default to https
  var protocol = src.startsWith('//') ? 'https:' : '';
  var parsedSrc = new Url(protocol + src);

  // Remove any existing scaler
  parsedSrc.set('pathname', parsedSrc.pathname.replace(pattern, ''));
  return parsedSrc;
};
var parseMediaSrc = function parseMediaSrc(src) {
  return new Url((src.startsWith('//') ? 'https:' : '') + src);
};
export default function getScaledImageSource(options) {
  var src = options.src,
    height = options.height,
    width = options.width;
  var correctScaler;
  var pattern;
  var mediaSrc = parseMediaSrc(src);
  if (mediaSrc && ASSET_IMAGE_SERVERS.includes(mediaSrc.hostname)) {
    correctScaler = joinPath(RESIZE_SCALER_PREFIX, String(width) + 'x' + String(height));
    pattern = new RegExp("^/" + joinPath(RESIZE_SCALER_PREFIX, resizePattern));
  } else {
    correctScaler = joinPath(SCALER_PREFIX, String(width), String(height));
    pattern = new RegExp("^/" + joinPath(SCALER_PREFIX, sizePattern, sizePattern));
  }
  var parsedSrc = parseSrc(src, pattern);
  if (ASSET_IMAGE_SERVERS.includes(parsedSrc.hostname)) {
    parsedSrc.hostname = parsedSrc.hostname.replace(ASSET_IMAGE_SERVERS[0], 'images.qa.autotrader.com').replace(ASSET_IMAGE_SERVERS[1], 'images.autotrader.com');
    parsedSrc.host = parsedSrc.host.replace(ASSET_IMAGE_SERVERS[0], 'images.qa.autotrader.com').replace(ASSET_IMAGE_SERVERS[1], 'images.autotrader.com');
  }
  if (isImageScalable(_extends({}, options, {
    hostname: parsedSrc.hostname
  }))) {
    // Prepend the correct scaler string after removing previous occurrence of the pattern'
    parsedSrc.set('pathname', correctScaler + parsedSrc.pathname);
    return parsedSrc.href;
  }
  return src;
}